import { Component, OnInit } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ShowcaseService } from '../services/showcase.service';
import { IShowcase } from '../interfaces/showcase';

import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
  selector: 'app-showcase',
  templateUrl: './showcase.component.html',
  styleUrls: ['./showcase.component.scss'],
  host: { 'class': 'wrapper-showcase' }
})
export class ShowcaseComponent implements OnInit {

  public selector: string = '.wrapper-showcase'
  public loadingShowcase:boolean = false

  public showcases: IShowcase[]

  constructor(private _showcaseService: ShowcaseService) { }

  ngOnInit(): void {
    this.showcases = []
    this.find()
  }

  find() {
    this.loadingShowcase = true

    this._showcaseService.list().subscribe(res => {
      if (res.success) {
        this.showcases = res.showcases
        for(let i in this.showcases) {
          this.showcases[i].ckStatus = this.showcases[i].status == 'A'
        }
      }
      this.loadingShowcase = false
    })
  }

  drop(event: CdkDragDrop<IShowcase[]>) {
    moveItemInArray(this.showcases, event.previousIndex, event.currentIndex);

    let ordem = []
    let n = 1
    for(let i in this.showcases) {
      ordem.push({
        idvitrine: this.showcases[i].idvitrine,
        ordem: n
      })
      ++n
    }
    this._showcaseService.patchOrdem({ordem}).subscribe(res=>{

    })
  }

  updateStatus(vitrine: IShowcase) {
    vitrine.status = vitrine.ckStatus ? 'A' : 'I'

    this._showcaseService.patch(vitrine.idvitrine, {status: vitrine.status}).subscribe(res=>{

    })
  }

  onRemove(vitrine: IShowcase, i: number) {
    Swal.fire({
      title: 'Você deseja excluir a vitrine, '+vitrine.nome+'?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!'
    }).then((result) => {
      if (result.value) {
        this.loadingShowcase = true

        this._showcaseService.delete(vitrine.idvitrine).subscribe(res => {
          if (res['success']) {
            this.showcases.splice(i, 1)
          }

          this.loadingShowcase = false
        })

      }
    })
  }

}
